import { trackEvent } from '@patrianna/analytics'

import BannerTile from 'components/BannerTile'
import { openDelayedBonusRewardDialog } from 'dialogs/RewardDialog/helpers'
import { useAppSelector } from 'src/store/hooks'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'
import { getOrderedDelayedBonusesSelector } from 'store/modules/bonusesFlow/selectors'

import type { BaseBonus } from '@patrianna/shared-patrianna-types/store/BonusesFlowModule'

function Rewards() {
  const orderedBonuses = useAppSelector(getOrderedDelayedBonusesSelector)
  const rewardBannerUrl = generateImageUrl('banners/reward/source.png', ImagesDirectory.BANNERS)

  const onClickHandler = (bonus: BaseBonus) => {
    trackEvent('clicked_on_banner', { category: 'reward-banner' })
    openDelayedBonusRewardDialog(bonus)
  }

  if (!orderedBonuses.length) {
    return null
  }

  return (
    <BannerTile
      onClick={() => onClickHandler(orderedBonuses[0])}
      src={rewardBannerUrl}
      alt='reward'
      dataTest='reward-banner'
    />
  )
}

export default Rewards
